import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import "./TimeGranularitySegmentedControl.scss";
const OPTIONS = [
    { value: "day", label: "Day" },
    { value: "week", label: "Week" },
    { value: "month", label: "Month" },
    { value: "year", label: "Year" },
];
export const TimeGranularitySegmentedControl = ({ value, onChange, }) => {
    return (_jsx("div", { className: "time-granularity-segmented-control", role: "group", "aria-label": "Time period", children: OPTIONS.map((opt) => (_jsx("button", { type: "button", className: `time-granularity-segment${value === opt.value ? " time-granularity-segment--selected" : ""}`, onClick: () => onChange(opt.value), "aria-pressed": value === opt.value, children: opt.label }, opt.value))) }));
};
